import { Inject } from '@odinjs/odin';

import providerContext from '@philips-emr/hpms-provider-commons/lib/context/provider-context';
import { FetchAPI, TableAPI } from '@philips-emr/tws-components/lib/components';
import Controller, { OnBeforeFetch, OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { SubmittableFragmentContext } from '@philips-emr/tws-core/lib/component/context';
import { FetchEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { isEmptyObject } from '@philips-emr/tws-utils';

import { LocatorProcedurePackageAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.LOCATOR_PROCEDURE_PACKAGE })
class LocatorProcedurePackageController extends BaseController {

  @Inject(Aliases.TABLE_PACKAGE)
  private tablePackage: TableAPI;
  @Inject('SubmittableFragmentContext')
  private submittableFragmentContext!: SubmittableFragmentContext;

  @OnMount(Aliases.PANEL_LOCATOR)
  onMountPanelLocator(): void {
    const { nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    this.context.set({ nrSeqProvider, nrSeqAccreditation });
  }

  @OnBeforeFetch(Aliases.FETCH_PROCEDURES)
  onBeforeFetch(event: FetchEvent): void {
    const api = event.target as FetchAPI;
    const parameters = api.getParameters();
    const { nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    api.setParameters({ ...parameters, nrSeqProvider, nrSeqAccreditation });
  }

  @OnClick(Aliases.BUTTON_SELECT)
  onClick(): void {
    const [selected] = this.tablePackage.getSelectedRows() || [];

    if (!isEmptyObject(selected)) {
      this.submittableFragmentContext.submit(new SubmitEvent({ record: selected }));
    }
  }
}

export {
  LocatorProcedurePackageController,
};
